import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/AskeperPerioperatifService";
import { AskeperPerioperatifInterface } from "@/types/askeper_perioperatif";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "askeper-perioperatif"
})
class AskeperPerioperatifStore extends VuexModule {
  loading = false;
  dataList: AskeperPerioperatifInterface[] = [];
  currentData: AskeperPerioperatifInterface | null = null;

  @Mutation
  SET_LIST(val: AskeperPerioperatifInterface[]) {
    this.dataList = val;
  }

  @Mutation
  SET_CURRENT(val: AskeperPerioperatifInterface | null) {
    this.currentData = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.dataList = [];
    this.currentData = null;
    this.loading = false;
  }

  @Action({ rawError: true })
  async fetchByRegister(registerId: string | number): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_LIST(response.data?.data || []);
  }

  @Action({ rawError: true })
  async fetchById(id: number): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.find(id).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
  }

  @Action({ rawError: true })
  async createAskeper(data): Promise<any> {
    this.SET_LOADING(true);
    const response = await Service.create(data).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  async updateAskeper(params: { id: number; data: any }): Promise<any> {
    this.SET_LOADING(true);
    const response = await Service.update(params.id, params.data).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  async deleteAskeper(id: number): Promise<void> {
    this.SET_LOADING(true);
    await Service.destroy(id).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(null);
  }

  @Action({ rawError: true })
  async signPre(params: { id: number; data: any }): Promise<any> {
    const response = await Service.signPre(params.id, params.data);
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  async signIntra(params: { id: number; data: any }): Promise<any> {
    const response = await Service.signIntra(params.id, params.data);
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  async signPost(params: { id: number; data: any }): Promise<any> {
    const response = await Service.signPost(params.id, params.data);
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(AskeperPerioperatifStore);
